import { ApiError, errorMessage } from "@lumora/bridge";
import { ViewModel } from "../mvvm/ViewModel.js";
/**
 * TOTP enrolment (#1501): setup -> verify the first code -> show the ten recovery codes once ->
 * "I saved these" ends the flow. The bridge stores the fresh token pair that verify returns.
 */
export class MfaEnrollmentViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ step: "intro", secret: "", otpauthUri: "", code: "", recoveryCodes: [], loading: false, error: null });
        this.client = client;
    }
    setCode(raw) {
        this.setState({ code: raw.replace(/\D/g, "").slice(0, 6), error: null });
    }
    async start() {
        if (this.state.loading)
            return false;
        this.setState({ loading: true, error: null });
        try {
            const res = await this.client.mfaSetup();
            this.setState({ loading: false, step: "scan", secret: res.secret, otpauthUri: res.otpauthUri, code: "" });
            return true;
        }
        catch (err) {
            this.setState({ loading: false, error: this.message(err, "Could not start setup. Please try again.") });
            return false;
        }
    }
    async verify() {
        if (this.state.loading || this.state.step !== "scan")
            return false;
        if (this.state.code.length !== 6) {
            this.setState({ error: "Enter the 6-digit code from your authenticator app." });
            return false;
        }
        this.setState({ loading: true, error: null });
        try {
            const res = await this.client.mfaVerifyTotp(this.state.code);
            this.setState({ loading: false, step: "codes", recoveryCodes: res.recoveryCodes, code: "", secret: "", otpauthUri: "" });
            return true;
        }
        catch (err) {
            this.setState({ loading: false, code: "", error: this.message(err, "Could not confirm the code. Please try again.") });
            return false;
        }
    }
    /** Recovery codes as a plain-text file body, one per line. */
    recoveryCodesText() {
        return ["Recovery codes: each works once.", "", ...this.state.recoveryCodes, ""].join("\n");
    }
    /** "I saved these": only valid on the codes step; wipes the codes from memory. */
    acknowledge() {
        if (this.state.step !== "codes")
            return false;
        this.setState({ step: "done", recoveryCodes: [] });
        return true;
    }
    message(err, fallback) {
        if (err instanceof ApiError) {
            if (err.code === "mfa_unavailable" || err.status === 503)
                return "Two-step sign-in is not available right now. Try again shortly.";
            if (this.state.step === "scan" && (err.status === 401 || err.status === 400 || err.code === "invalid_credentials")) {
                return "That code did not match. Check the clock on your phone and try again.";
            }
        }
        return errorMessage(err, fallback);
    }
}
//# sourceMappingURL=MfaEnrollmentViewModel.js.map